import { createReduxAsyncThunk } from 'shared/utils';

import { stationsAPI } from 'entities/stations';

import { STATIONS_STATE } from '../../constants';

import {
  StationsState,
  Station
} from '../../types';

export const getSelectedStationPrices = createReduxAsyncThunk<
  StationsState['selectedStation']['prices'],
  Station['code']
>(
  `${STATIONS_STATE}/getStationPrices`,
  async (stationCode, { signal, getState }) => {
    const { data } = await stationsAPI.getStationPrices(stationCode, signal);
    // @ts-ignore
    const state = getState()[STATIONS_STATE] as StationsState;

    if (state.selectedStationOnMap?.code !== stationCode) {
      return;
    }

    return data;
  }
);
